@if (!isDropDown) {
<a class="download-item" [attr.data-track]="dataTrack ? dataTrack : null" (click)="clicked.emit()">
    <div class="d-flex align-items-center">
        <div class="download-item-file-icon">
            <fa-icon [icon]="['fal', icon]" size="2x"></fa-icon>
        </div>
        <div class="download-item-label">
            {{ label }}
        </div>
    </div>
    <div class="d-flex">
        <div class="download-item-download-icon">
            <fa-icon [icon]="['fal', 'arrow-to-bottom']" size="2x"></fa-icon>
        </div>
    </div>
</a>
} @else {
<div ngbDropdown [placement]="'bottom-right'">
    <a class="download-item" ngbDropdownToggle>
        <div class="d-flex align-items-center">
            <div class="download-item-file-icon">
                <fa-icon [icon]="['fal', 'file-archive']" size="2x"></fa-icon>
            </div>
            <div class="download-item-label">
                {{ label }}
            </div>
        </div>
        <div class="d-flex">
            <div class="download-item-download-icon">
                <fa-icon [icon]="['fal', 'arrow-to-bottom']" size="2x"></fa-icon>
            </div>
        </div>
        <div class="dropdown-menu show-top-border add-margin" ngbDropdownMenu>
            <ng-content></ng-content>
        </div>
    </a>
</div>
}
